<template>
    <div>
        <el-select :size="size" clearable :value="value" placeholder="请选择角色" @change="changeRole" style="width: 100%;">
            <el-option
                    v-for="item in roleList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
            </el-option>
        </el-select>
    </div>
</template>

<script>
import {getRoleList} from '@/api/role'

export default {
    name: '',
    data() {
        return {
            roleList: []
        }
    },
    props: {
        value: {
            default: null
        },
        include: {
            default: false
        },
        size:{
            default:'normal'
        }
    },
    methods: {
        // 获取角色列表
        getRole() {
            let param = {}
            param.include = this.include
            getRoleList(param).then(response => {
                console.log('角色列表',param,response.data)
                if(response.code!=200){
                    return this.$message.error(response.msg)
                }
                this.roleList = []
                // this.roleList.push({id: null, name: '请选择'})
                response.data.forEach(item=>{
                    this.roleList.push(item)
                })
                // this.roleList = response.data
            })
        },
        changeRole(val) {
            console.log("computed触发了changeRole。。。" + val)
            this.$emit('updateRoleId', val)
        }
    },
    created(){
        this.getRole()
    }
}
</script>

<style scoped>

</style>
